module.exports = __webpack_public_path__ + "img/nav-thumbnail-fft-maps.f157990d.png";